import Vue from 'vue'
import Router from 'vue-router'

import Struk from '@/components/Struk'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/:guid',
      name: 'Struk',
      component: Struk
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js